import { render, staticRenderFns } from "./StoreCustomers.vue?vue&type=template&id=c8b8fd1a"
import script from "./StoreCustomers.vue?vue&type=script&lang=js"
export * from "./StoreCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports